import useRouter from 'packages/hooks/use-router';
import {Route, Switch} from 'react-router-dom';
import Accounts from '../accounts/Accounts';
import ClubsTable from '../clubs/ClubsTable';
import Rounds from '../rounds/Rounds';
import Standings from '../standings/Standings';
import Tournaments from '../tournaments/Tournaments';
import useCommonStyles from '../../common-utils/common-styles';
import NationalRanking from '../national-ranking/NationalRanking';

const Content = () => {
  const {match} = useRouter();
  const common = useCommonStyles();
  return (
    <div className={common.gray_background}>
      <Switch>
        <Route exact path={`${match.url}`} component={Tournaments} />
        <Route path={`${match.url}/accounts`} component={Accounts} />
        <Route path={`${match.url}/clubs`} component={ClubsTable} />
        <Route path={`${match.url}/rounds`} component={Rounds} />
        <Route path={`${match.url}/standings`} component={Standings} />
        <Route path={`${match.url}/national`} component={NationalRanking} />
      </Switch>
    </div>
  );
};

export default Content;
